import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useOrderContext } from "../../../../contexts/OrderContext";
import { SavedProgressReducerActionTypes } from "../../../../contexts/reducers/savedProgressReducer";
import { isValidDeliveryDate } from "../../../../utils/helper";
import DeliveryDatePicker from "../../components/deliveryDatePicker/DeliveryDatePicker";
import BaseContent from "../BaseContent";

interface EnterTimesScreenProps {}

const EnterTimesScreen = (props: EnterTimesScreenProps) => {
  const { t } = useTranslation();
  const { savedProgress, dispatchSavedProgress } = useOrderContext();

  const [plannedDelivery, setPlannedDelivery] = useState<Date | null>(null);

  const loadSavedProgress = () => {
    if (!savedProgress || !savedProgress.plannedDelivery) return;

    setPlannedDelivery(savedProgress.plannedDelivery);
  };

  const saveProgress = () => {
    if (!plannedDelivery || !isValidDeliveryDate(plannedDelivery)) return;

    dispatchSavedProgress({
      type: SavedProgressReducerActionTypes.SET_PROP,
      property: "plannedDelivery",
      value: plannedDelivery,
    });
  };

  useEffect(() => {
    loadSavedProgress();
  }, []);

  return (
    <BaseContent
      screenName={"enterTimesScreen"}
      disableNext={!isValidDeliveryDate(plannedDelivery)}
      proceedButtonText={t("proceedDocuments")}
      saveProgress={saveProgress}
    >
      <div className="form-component">
        <DeliveryDatePicker
          selectedDateTime={plannedDelivery}
          onChange={(dateTime) => setPlannedDelivery(dateTime)}
        />
      </div>
    </BaseContent>
  );
};
export default EnterTimesScreen;
